/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserSelectionTagUserList } from '../../models/user-selection-tag-user-list';

export interface TagGetUserSelectionTagUserList$Params {

/**
 * GUID of the tag
 */
  tagId: string;
}

export function tagGetUserSelectionTagUserList(http: HttpClient, rootUrl: string, params: TagGetUserSelectionTagUserList$Params, context?: HttpContext): Observable<StrictHttpResponse<UserSelectionTagUserList>> {
  const rb = new RequestBuilder(rootUrl, tagGetUserSelectionTagUserList.PATH, 'get');
  if (params) {
    rb.path('tagId', params.tagId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserSelectionTagUserList>;
    })
  );
}

tagGetUserSelectionTagUserList.PATH = '/tag/user-selection/{tagId}/user/list';
